import { GetDomain } from "../../Helpers";

let domain = GetDomain();

export interface SDThing {
    "@type": string;
    "name": string;
    "sameAs"?: string;
}

export class SDPerson implements SDThing {
    "@type": string = "Person";
    "name": string;
    "sameAs"?: string;
}

export class SDReviewOrg implements SDThing {
    "@type": string = "Organization";
    "name": string;
    "sameAs"?: string;
}

export class SDReview {
    "@type": string = "Review";
    "url": string = GetDomain() + "/Info/Testimonials";
    "author": SDPerson;
    "publisher": SDReviewOrg;
    "datePublished": string;
    "reviewBody": string;
    "inLanguage": string = "en";
    "itemReviewed"?: any;
}

export class SDOrganization {
    "@context": string = "http://schema.org";
    "@type": string = "Organization";
    "brand": string = "Life-Assist";
    "name": string = "Life-Assist";
    "slogan": string = "Helping Heroes Save Lives";
    "description": string = "Emergency Medical Supplies for the First Responder";
    "logo": string = domain + "/Content/img/layout/logo.jpg";

    "url": string = domain;
    "sameAs": Array<any> = [
        "https://www.facebook.com/LifeAssistEMS/",
        "https://twitter.com/LifeAssistEMS",
        "https://www.indeed.com/cmp/Life--assist-Inc.",
        "https://www.linkedin.com/company/life-assist-inc"
    ];
    "potentialAction": any = {
        "@type": "SearchAction",
        "target": domain + "/Search?keyword={search_term_string}",
        "query-input": "required name=search_term_string"
    };
    "address": any = {
        "@type": "PostalAddress",
        "addressLocality": "Rancho Cordova",
        "addressRegion": "CA",
        "postalCode": "95742",
        "streetAddress": "11277 Sunrise Park Dr"
    };
    "telephone": string = "+1-800-824-6016";
    "email": string = "CustomerCare(at)life-assist.com";
    "faxNumber": string = "+1-800-290-9794";
    "contactPoint": Array<any> = [
        {
            "@type": "ContactPoint",
            "telephone": "+1-800-824-6016",
            "faxNumber": "+1-800-290-9794",
            "contactType": "Customer Care Support",
            "contactOption": "TollFree",
            "areaServed": "US"
        }
    ];
    "duns": string = "096899414";
    "taxID": string = "94-2440500";
    "foundingDate": string = "1977";
    "legalName": string = "Life-Assist, Inc.";
    "image": string = domain + "/Content/img/layout/logo.jpg";
}

export class SDOfferCatalog {
    "@context"?: string = "http://schema.org";
    "@type": string = "OfferCatalog";
    "name": string;
    "description"?: string;
    "url"?: string;
    "itemListElement"?: Array<SDOfferCatalog>;
}

interface ReviewModel {
    Agency: string;
    Comment: string;
    DateTimeStamp: string;
    Name: string;
    State: string;
}

export class SDBusiness {
    "@context": string = "http://schema.org";
    "@type": string = "MedicalBusiness";
    "name": string = "Life-Assist";
    "slogan": string = "Helping Heroes Save Lives";
    "description": string = "Emergency Medical Supplies for the First Responder";
    "logo": string = domain + "/Content/img/layout/logo.jpg";

    "url": string = domain;
    "sameAs": Array<any> = [
        "https://www.facebook.com/LifeAssistEMS/",
        "https://twitter.com/LifeAssistEMS",
        "https://www.indeed.com/cmp/Life--assist-Inc.",
        "https://www.linkedin.com/company/life-assist-inc"
    ];
    "potentialAction": any = {
        "@type": "SearchAction",
        "target": domain + "/Search?keyword={search_term_string}",
        "query-input": "required name=search_term_string"
    };

    "hasOfferCatalog": SDOfferCatalog;
    "openingHoursSpecification": Array<any> = [
        {
            "@type": "OpeningHoursSpecification",
            "closes": "17:00:00",
            "dayOfWeek": "http://schema.org/Monday",
            "opens": "07:00:00"
        },
        {
            "@type": "OpeningHoursSpecification",
            "closes": "17:00:00",
            "dayOfWeek": "http://schema.org/Tuesday",
            "opens": "07:00:00"
        },
        {
            "@type": "OpeningHoursSpecification",
            "closes": "17:00:00",
            "dayOfWeek": "http://schema.org/Wednesday",
            "opens": "07:00:00"
        },
        {
            "@type": "OpeningHoursSpecification",
            "closes": "17:00:00",
            "dayOfWeek": "http://schema.org/Thursday",
            "opens": "07:00:00"
        },
        {
            "@type": "OpeningHoursSpecification",
            "closes": "17:00:00",
            "dayOfWeek": "http://schema.org/Friday",
            "opens": "07:00:00"
        }
    ];
    "currenciesAccepted": string = "USD";
    "paymentAccepted": string = "Cash, Credit Card";
    "priceRange": string = "$ - $$$";

    "geo": any = {
        "@type": "GeoCoordinates",
        "latitude": "38.5947064",
        "longitude": "-121.2622372"
    };
    "address": any = {
        "@type": "PostalAddress",
        "addressLocality": "Rancho Cordova",
        "addressRegion": "CA",
        "postalCode": "95742",
        "streetAddress": "11277 Sunrise Park Dr"
    };
    "telephone": string = "+1-800-824-6016";
    "email": string = "CustomerCare(at)life-assist.com";
    "faxNumber": string = "+1-800-290-9794";
    "contactPoint": Array<any> = [
        {
            "@type": "ContactPoint",
            "telephone": "+1-800-824-6016",
            "faxNumber": "+1-800-290-9794",
            "contactType": "Customer Care Support",
            "contactOption": "TollFree",
            "areaServed": "US"
        }
    ];

    "duns": string = "096899414";
    "taxID": string = "94-2440500";
    "foundingDate": string = "1977";
    "legalName": string = "Life-Assist, Inc.";

    "image": string = domain + "/Content/img/layout/logo.jpg";
    "aggregateRating"?: any;
    "reviews"?: Array<SDReview>;

    constructor() {
        if (!window.SData) {
            return;
        } else if (!window.SData.ProductSections) {
            return;
        };

        let sectionsCatalog: Array<any> = window.SData.ProductSections.map((item) => {

            let catalog = new SDOfferCatalog();
            catalog["@type"] = "OfferCatalog";
            catalog.name = item.Title;
            catalog.description = item.Description;
            catalog.url = domain + "/products/" + item.Slug + "/" + item.NavID + "/";

            return catalog;
        })

        this.hasOfferCatalog = new SDOfferCatalog();
        this.hasOfferCatalog.name = "Emergency Medical Supply Product Sections";

        this.hasOfferCatalog.itemListElement = sectionsCatalog;

        this.hasOfferCatalog.itemListElement.push({
            "@type": "OfferCatalog",
            name: "On Sale",
            url: domain + "/products/on-sale/"
        });

        this.hasOfferCatalog.itemListElement.push({
            "@type": "OfferCatalog",
            name: "New Products",
            url: domain + "/products/new-products/"
        });

        if (window.location.pathname === "/") {
            let reviewModels: Array<ReviewModel> = window.Model.Testimonials;
            let reviews = [];

            reviewModels.forEach((review) => {
                let entry = new SDReview();
                entry.author = new SDPerson();
                entry.author.name = (!review.Name || !review.Name.trim()) ? "Anonymous" : review.Name;
                entry.datePublished = review.DateTimeStamp;
                entry.publisher = new SDReviewOrg();
                entry.publisher.name = review.Agency;
                entry.reviewBody = review.Comment;

                reviews.push(entry);
            })
            this.aggregateRating = {
                "@type": "AggregateRating",
                "ratingValue": "5",
                "ratingCount": "2"
            }
            this.reviews = reviews;
        }
    }
}

export class SDWebsite {
    "@context": string = "http://schema.org";
    "@type": string = "WebSite";
    "name": string = "Life-Assist, Inc.";
    "url": string = "https://www.life-assist.com/";
    "description": "Emergency Medical Supplies for the First Responder";
    "potentialAction": any = {
        "@type": "SearchAction",
        "target": "https://www.life-assist.com/Search?keyword={search_term_string}",
        "query-input": "required name=search_term_string"
    };
    "image": string = "https://www.life-assist.com/Content/img/layout/logo.jpg";
}

// Breadcrumbs
export interface SDItem {
    "@id": string;
    "name": string;
}

export class SDListItem {
    "@type": string;
    "position": number;
    "item": SDItem;

    constructor(url, itemName, position) {
        if (!itemName) {
            return;
        }

        this["@type"] = "ListItem";
        this.position = position;
        this.item = {
            "@id": url,
            name: itemName
        }
    }
}

export class SDBreadcrumbs {
    "@context": string = "http://schema.org";
    "@type": string = "BreadcrumbList";
    "itemListElement": Array<SDListItem>;
    constructor(items: Array<SDListItem>) {
        this.itemListElement = items;
    }
}

// Product SD models
export class SDBrand {
    "@type": string = "Thing";
    "name": string;
}

export class SDUnitOfMeasure {
    "@type": string = "QuantitativeValue";
    "value": string;
    "unitText": string;
}

export class SDProductPrices {
    "@type": string = "UnitPriceSpecification";
    "price": number;
    "priceCurrency": string = "USD";
    "referenceQuantity": SDUnitOfMeasure;
};

export class SDProductOffer {
    "@type": string = "Offer";
    //"@type": string = "AggregateOffer";
    //"itemOffered"?: SDProductModel;
    "priceCurrency": string = "USD";
    "price": number;
    //"priceValidUntil": string;
    "seller": string = "Life-Assist";
    "availability": string = "http://schema.org/InStock";
    "itemCondition": string = "http://schema.org/NewCondition";
    //"priceSpecification": SDProductPrices;
    //"highPrice": number;
    //"lowPrice": number;
    "url": string;
    //"offerCount": number;
    //"offers": SDProductModel;
}

//NO REF.
//export class SDProductModel {
//    "@type": string = "ProductModel";
//    "name": string;
//    "url": string; //url to details page
//    "manufacturer": string; //SDmanufacturer
//    "productid": string; //SDproductid    
//}

export class SDProduct {
    "@context": string = "http://schema.org";
    "@type": string = "Product";
    "sku": string; //SDsku
    "mpn": string; //SDmpn
    "image": string; //imageURL
    "name": string; //SDname    
    "description": string; //SDdescription
    "brand": SDBrand;
    //"offers": Array<SDProductOffer>;
    "offers": SDProductOffer;
    "isAccessoryOrSparePartFor"?: string; // url to details page

    constructor(product, count) {
        let self = this;
        if (product != null) {
            let imageFilename = product.ImageName != '' ? product.ImageName : null;

            self.sku = product.SDsku || product.ItemID;
            self.mpn = product.VendItemNo;
            self.image = domain + "/Content/ProductImages/300x225/" + imageFilename;
            self.name = product.SDname;
            self.description = product.SDdescription;

            self.brand = new SDBrand();
            self.brand.name = product.SDbrand;

            // Use only first product due to changes with Google
            self.offers = new SDProductOffer();

            if (product.Status === "IN STOCK") {
                self.offers.availability = "https://schema.org/InStock";
            }
            else {
                self.offers.availability = "https://schema.org/LimitedAvailability";
            }

            self.offers.itemCondition = "http://schema.org/NewCondition";
            self.offers.url = domain + window.location.pathname;

            //should not be an array not an obj
            //self.offers.price = product.UoMPrices()[0].Price;
            //self.offers.price = product.UoMPrices[0].Price;

            const formatToCurrency = amount => {
                return amount.toFixed(2).replace(/\d(?=(\d{3})+\.)/g, "$&");
            };
            self.offers.price = formatToCurrency(product.UoMPrices[0].Price);
        }
    }
}

// Product Q&A + FAQ Page models
interface SDComment {
    "@context": string;
    "@type": string;
    "text"?: string;
    "author": SDPerson;
    "dateCreated"?: string;
}

export class SDQuestion implements SDComment {
    "@context": string
    "@type": string = "Question";
    "dateCreated"?: string;
    "name": string;
    "text"?: string;
    "author": SDPerson;
    "acceptedAnswer": SDComment;
}

export class SDAnswer implements SDComment {
    "@context": string = "http://schema.org";
    "@type": string = "Answer";
    "text": string;
    "author": SDPerson;
    "dateCreated"?: string;
}

export class SDFAQPage {
    "@context": string = "https://schema.org";
    "@type": string = "FAQPage";
    "mainEntity": Array<SDQuestion>;
}

// For later use if we ever implement a public Q&A similar to Amazon like initially proposed
//export class SDResultComment {
//    "@context": string = "http://schema.org";
//    "@type": string = "Answer";
//    "dateCreated"?: string;
//    "parentItem"?: SDQuestion;
//    "text": string;
//}

//export class SDReplyAction {
//    "@context": string = "http://schema.org";
//    "@type": string = "ReplyAction";
//    "agent": SDPerson;
//    "recipient": SDPerson;
//    "resultComment": SDResultComment;
//}

// For use later on product details when we have these fields: duration, thumbnail, uploadDate
export class SDVideoObject {
    "@context": string = "http://schema.org/";
    "@type": string = "VideoObject";
    "description": string;
    "name": string;
    "contentUrl": string;
    "thumbnail": string;
    "uploadDate": string;
    "duration"?: string;
}